import React from "react";
import { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import "./style.scss"
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { Button, Switch } from "@mui/material";
import { BsPencil } from "react-icons/bs";
import { RiDeleteBin6Line } from "react-icons/ri";
import { Formatter } from "utils/formatter";
import Pagination from '@mui/material/Pagination';
import { Link } from "react-router-dom";
import { findCategoryIdBySlug } from "utils/createSlug";
import { generateSlug } from "utils/createSlug";
import { MyContext } from "../theme/adminLayout";
import { useContext } from "react";
import Swal from "sweetalert2";
import { PacmanLoader } from "react-spinners";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import ModalAdminManage from "component/admin/modal_adminManage";
import { IoBanSharp } from "react-icons/io5";
import { LuRefreshCcw } from "react-icons/lu";
import { blockAdmin, getAdminsByPermission, getAdminsBySearch, getAllAdmins, getAllPermissions, resetPasswordForAdmin, unblockAdmin } from "services/admin/adminService";
import { introspective } from "services/tokenService";

const AdminList = () => {
    const context = useContext(MyContext);
    const { slug } = useParams(); // Lấy slug từ URL
    const token = localStorage.getItem("token")
    const [modal, setModal] = useState(false);
    const [selectedAdmin, setSelectedAdmin] = useState();
    const [refreshFetchAdmins, setRefreshFetchAdmins] = useState(false); 

    const toggleModal = (admin) => {
        setSelectedAdmin(admin);
        setModal((prev) => !prev);
    };

    const [adminPermission, setAdminPermission] = useState(""); // lưu xem có quyền qly admin không
    
    useEffect(() => {
        const fetchPermissions = async () => {
            try {
                const response = await introspective(token);
                if (response.data) {
                    setAdminPermission(response.data.permissions.some(permission => permission.id === 5)); // id 5 là qly admin
                }
            } 
            catch (error) {
                console.log("introspective failed:", error);
            } 
        };

        fetchPermissions();

    }, [token]);
    console.log(adminPermission)

    const [isLoading, setIsLoading] = useState(false);

    const [isHidden, setIsHidden] = useState(false)
    
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const [page, setPage] = useState(Number(searchParams.get('page') || 1));
    // const page1 = searchParams.get('page') || 1;
    const [searchText, setSearchText] = useState(searchParams.get("q") || '');
    const query = searchParams.get("q")

    const [admins, setAdmins] = useState([]);
    // const [page, setPage] = useState(+page1);
    const [totalPage, setTotalPage] = useState(1);
    const navigate = useNavigate();
    

    const [permissionVal, setPermissionVal] = useState(0); // permissions của select
    
    const [permissions, setPermissions] = useState([]);
    // permissions
    useEffect(() => {
        const fetchPermissions = async() => {
            try {
                const response = await getAllPermissions(token);
                setPermissions(response.data);
            } catch (error) {
                console.error("Error fetching permissions:", error);
            }
        };

        fetchPermissions();
    },[token])

    //getAdminsByPermission
    useEffect(() => {
        const permissionId = findCategoryIdBySlug(permissions, slug);
        if (permissionId) {
            setPermissionVal(permissionId);
            const fetchAdminsByPermission = async () => {
                setIsLoading(true)
                try {
                    const response = await getAdminsByPermission(token, permissionId, page - 1);
                    if (response && response.data) {
                        setAdmins(response.data.content);
                        setTotalPage(response.data.page.totalPages);
                    }
                } 
                catch (error) {
                    console.error("fetchAdminsByPermission", error);
                } 
                finally {
                    setIsLoading(false);
                }
            };
            fetchAdminsByPermission();
        }
        // else if (slug === "alls") {
        //     setPermissionVal(0); // allBoooks
        // }
        
        window.scrollTo(0, 0);
    }, [slug, page, permissions, token, refreshFetchAdmins]);

    // getAllAdmins
    useEffect(() => {
        // if (permissionVal === 0) {
        if (slug === "all") {
            const fetchAllAdmins = async () => {
                setIsLoading(true)
                try {
                    const response = await getAllAdmins(token, page - 1);
                    if (response && response.data) {
                        setAdmins(response.data.content);
                        setTotalPage(response.data.page.totalPages);
                    }
                } 
                catch (error) {
                    console.error("fetchAllAdmins", error);
                } 
                finally {
                    setIsLoading(false);
                }
                
            };
            fetchAllAdmins();
        }
    }, [permissionVal, page, token, slug, refreshFetchAdmins]);
    console.log(admins)

    useEffect(() => {
        if (slug === "search") {
            const fetchAdminsBySearch = async () => {
                setIsLoading(true)
                try {
                    const response = await getAdminsBySearch(token, searchText.trim(), page - 1)
                    if (response && response.data && response.data.content && response.data.page) {
                        setAdmins(response.data.content);
                        setTotalPage(response.data.page.totalPages);
                    }
                } 
                catch (error) {
                    console.log("fetchAdminsBySearch", error)
                }
                finally {
                    setIsLoading(false)
                }
                
            };
            fetchAdminsBySearch();
        }
    }, [page, token, slug, query, refreshFetchAdmins]);

    const handleBlockAdmin = async (email) => {
        const result = await Swal.fire({
            title: "Bạn chắc chắn muốn chặn?",
            text: `Xác nhận sẽ chặn người dùng ${email}"!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Xác nhận chặn!",
            cancelButtonText: "Huỷ"
        });
        
        if (result.isConfirmed) {
            setIsLoading(true)
            try {
                const response = await blockAdmin(token, email);
                console.log(response.data.message)
                if (response.status === 200) {
                    Swal.fire({
                        title: "Chặn thành công!",
                        text: `Người dùng "${email}" đã bị chặn.`,
                        icon: "success"
                    }).then(() => {
                        // window.location.reload();
                        setRefreshFetchAdmins((prev) => !prev);
                    });
                }
                else {
                    Swal.fire({
                        title: "Có lỗi xảy ra!",
                        text: "Chặn người dùng thất bại. Vui lòng kiểm tra lại thông tin.",
                        icon: "error"
                    });
                }
            } 
            catch (error) {
                console.log("blockAdmin", error)
                Swal.fire({
                    title: "Có lỗi xảy ra!",
                    text: "Chặn người dùng thất bại. Vui lòng kiểm tra lại thông tin.",
                    icon: "error"
                });
            }
            finally {
                setIsLoading(false)
            }
            
        }
    };

    const handleUnBlockAdmin = async (email) => {
        const result = await Swal.fire({
            title: "Bạn chắc chắn muốn bỏ chặn?",
            text: `Xác nhận sẽ bỏ chặn người dùng ${email}"!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Xác nhận bỏ chặn!",
            cancelButtonText: "Huỷ"
        });
        
        if (result.isConfirmed) {
            setIsLoading(true)
            try {
                const response = await unblockAdmin(token, email);
                if (response.status === 200) {
                    Swal.fire({
                        title: "Bỏ chặn thành công!",
                        text: `Người dùng "${email}" đã được bỏ chặn.`,
                        icon: "success"
                    }).then(() => {
                        // window.location.reload();
                        setRefreshFetchAdmins((prev) => !prev);
                    });
                }
                else {
                    Swal.fire({
                        title: "Có lỗi xảy ra!",
                        text: "Bỏ chặn người dùng thất bại. Vui lòng kiểm tra lại thông tin.",
                        icon: "error"
                    });
                }
            } 
            catch (error) {
                console.log("unblockAdmin", error)
                Swal.fire({
                    title: "Có lỗi xảy ra!",
                    text: "Bỏ chặn người dùng thất bại. Vui lòng kiểm tra lại thông tin.",
                    icon: "error"
                });
            }
            finally {
                setIsLoading(false)
            }
            
        }
    };

    const handleResetPassword = async (email) => {
        const result = await Swal.fire({
            title: "Bạn chắc chắn muốn reset mật khẩu?",
            text: `Xác nhận sẽ reset mật khẩu người dùng ${email}"!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Xác nhận reset!",
            cancelButtonText: "Huỷ"
        });
        
        if (result.isConfirmed) {
            setIsLoading(true)
            try {
                const response = await resetPasswordForAdmin(token, email);
                console.log(response.data.message)
                if (response.status === 200) {
                    Swal.fire({
                        title: "Reset mật khẩu thành công!",
                        text: `Mật khẩu của người dùng "${email}" đã được reset.`,
                        icon: "success"
                    }).then(() => {
                        // window.location.reload();
                        // setRefreshFetchAdmins((prev) => !prev);
                    });
                }
                else {
                    Swal.fire({
                        title: "Có lỗi xảy ra!",
                        text: "Reset mật khẩu thất bại. Vui lòng kiểm tra lại thông tin.",
                        icon: "error"
                    });
                }
            } 
            catch (error) {
                console.log("resetPassword", error)
                Swal.fire({
                    title: "Có lỗi xảy ra!",
                    text: "Reset mật khẩu thất bại. Vui lòng kiểm tra lại thông tin.",
                    icon: "error"
                });
            }
            finally {
                setIsLoading(false)
            }
            
        }
    };

    const handleChangePermission = (event) => {
        setPermissionVal(event.target.value);
    };

    const handleChangePage = (event, value) => {
        // if (permissionVal === 0) {
        if (slug === "all") {
            setPage(value);
            navigate(`/admin/list-admin/all?page=${value}`);
        }
        else if (slug === "search") {
            setPage(value);
            navigate(`/admin/list-admin/search?q=${searchText.trim()}&page=${value}`);
        }
        else {
            const permission = permissions.find(permission => permission.id === permissionVal);
            const slug = generateSlug(permission.name);  
            setPage(value);
            navigate(`/admin/list-admin/${slug}?page=${value}`);
        }
    };

    const handlePermissionClick = (id) => {
        if (id === 0) {
            setPermissionVal(id);
            navigate(`/admin/list-admin/all`);
        }
        else {
            const permission = permissions.find(permission => permission.id === id);
            const slug = generateSlug(permission.name); 
            setPermissionVal(id);
            navigate(`/admin/list-admin/${slug}`);
        }
    };


    const handleSearchChange = (e) => {
        const text = e.target.value;
        setSearchText(text);
    };
  
    const handleKeyDownSearch = (event) => {
        if (event.key === "Enter") {
           navigate(`/admin/list-admin/search?q=${searchText.trim()}`)
           setPermissionVal(0)
           setPage(1)
           setIsHidden(false)
        }
    }

    return (
        <div className="AdminList">
            <div className="card border-0 p-4 mt-5 mb-3">
                <div className="headCard d-flex">
                    <h5>Tất cả Admin</h5>
                    <Link className="ms-auto">
                        <Button 
                            onClick={() => {
                                if (!adminPermission) {
                                    Swal.fire({
                                        title: "Không có quyền",
                                        text: "Bạn không có quyền thêm mới admin.",
                                        icon: "error"
                                    });
                                }
                                else {
                                    toggleModal(null);
                                }
                            }}
                        
                        >
                            Thêm mới admin
                        </Button>
                    </Link>
                    {/* {modal && (
                        <ModalAdminManage  
                        //   adminID={selectedAdmin}  
                        onClose={() => {
                            setModal(false); // Đóng modal
                        }}
                        />
                    )}  */}
                </div>
                <hr />

                <div className="row cardFilters">
                    <div className="col-4">
                        <h4>Quyền quản lí</h4>
                        <Select
                            className="custom-select"
                            value={permissionVal}
                            onChange={handleChangePermission}
                            displayEmpty
                            inputProps={{ 'aria-label': 'Without label' }}
                            MenuProps={{
                                disableScrollLock: true,
                                PaperProps: {
                                    style: {
                                        maxHeight: 200, 
                                        overflowY: 'auto',
                                    },
                                },
                            }}
                            sx={{
                                '&.MuiOutlinedInput-root': {
                                    // '& fieldset': {
                                    //     borderColor: 'red',
                                    // },
                                    '&:hover fieldset': {
                                        borderColor: '#9d2ff7',
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: '#9d2ff7',
                                    },
                                },
                            }}
                        >
                            <MenuItem disabled>
                                <em>Quyền quản lí</em>
                            </MenuItem>

                            <MenuItem value={0} onClick={() => handlePermissionClick(0)} >Tất cả quyền</MenuItem>

                            {permissions && permissions.length > 0 ? (
                                permissions.map((permission, index) => (
                                    <MenuItem key={index} value={permission.id} onClick={() => handlePermissionClick(permission.id)}>{permission.desc}</MenuItem>
                                ))
                            ) : (
                                <MenuItem disabled>No permissions available</MenuItem>
                            )}
                        </Select>
                    </div>
                    <div className="col-8">
                        <h4>Tìm kiếm</h4>
                        <input 
                            type="text" 
                            value={searchText}
                            placeholder="Search...!!!" 
                            onChange={handleSearchChange} 
                            onKeyDown={handleKeyDownSearch}
                        />
                    </div>
                </div>

                <div className="table-responsive mt-3">
                    <table className="table table-bordered v-align">
                        <thead className="thead-dark">
                            <tr>
                                <th>ID</th>
                                <th>HỌ VÀ TÊN</th>
                                <th>EMAIL</th>
                                <th>SỐ ĐIỆN THOẠI</th>
                                <th>QUYỀN QUẢN LÍ</th>
                                <th>HOẠT ĐỘNG</th>
                                <th>ACTION</th>
                            </tr>
                        </thead>

                        <tbody>
                            {admins && admins.length > 0 && (
                                admins.map((admin, index) => (
                                    <tr key={index}>
                                        <td>{index+1}</td>
                                        <td>
                                            {admin.fullName}
                                        </td>
                                        <td>{admin.email}</td>
                                        <td>{admin.phoneNumber ? admin.phoneNumber : 'không có'}</td>
                                        <td>
                                            <ul className="list list-inline tags">
                                                {admin.permissions && admin.permissions.length > 0 &&  
                                                    admin.permissions.map(permission => (
                                                        <li 
                                                            key={permission.id}
                                                            className="list-inline-item"
                                                        >
                                                            <span>{permission.desc}</span>
                                                        </li>
                                                    ))
                                                }
                                            </ul>
                                        </td>
                                        <td>
                                            <Switch
                                                checked={!admin.isBlocked}
                                                onChange={() => !admin.isBlocked ? handleBlockAdmin(admin.email) : handleUnBlockAdmin(admin.email)}
                                                // color="secondary"
                                                sx={{
                                                    "& .MuiSwitch-switchBase.Mui-checked": {
                                                    color: "rgb(34, 197, 94)",
                                                    },
                                                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                                                    backgroundColor: "rgb(34, 197, 94)",
                                                    },
                                                }}
                                            />
                                        </td>
                                        <td>
                                            <div className="actions d-flex align-items-center justify-content-center">
                                                <>
                                                    <Button 
                                                        className="secondary" 
                                                        color="secondary"
                                                        onClick={() => toggleModal(admin)}
                                                    >
                                                        <BsPencil />
                                                    </Button>
        
                                                    <Button 
                                                        className="primary" 
                                                        color="primary"
                                                        onClick={() => handleResetPassword(admin.email)}
                                                    >
                                                        <LuRefreshCcw/>
                                                    </Button>
                                                    
                                                    {/* <Button 
                                                        className="error" 
                                                        color="error"
                                                    > 
                                                        <IoBanSharp />
                                                    </Button> */}
                                                </>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )} 
                        </tbody>
                        {modal && (
                            <ModalAdminManage  
                                admin={selectedAdmin}  
                                onClose={(isRefresh = false) => {
                                    setModal(false);
                                    if (isRefresh) {
                                        setRefreshFetchAdmins((prev) => !prev);  // Refresh fetch admins nếu cần
                                    }
                                }}  
                            />
                        )} 
                    </table>

                    <div className="d-flex tableFooter">
                        <Pagination 
                            className="ms-auto" 
                            count={totalPage} 
                            color="secondary"
                            page={page} 
                            onChange={handleChangePage}
                        />
                    </div>
                </div>
            </div>
            
            {isLoading && (
                <div className="modal">
                    <div className="overlay_loading">
                        <div className="modal-content_loading">
                            <div className="d-flex">
                            <PacmanLoader color="#5e2e86"/>
                            </div>
                        </div>
                    </div>
                </div>
            )} 
        </div>
    )
}

export default AdminList;